module.exports = __webpack_public_path__ + "img/Group 249.df46c0d3.svg";